module.exports = ":host {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 589
// module chunks = 8